<template>
  <div
    :class="[
      'responsive-navbar offcanvas offcanvas-end',
      { show: stateStoreInstance.open },
    ]"
    tabindex="-1"
    id="navbarOffcanvas"
  >
    <div class="offcanvas-header">
      <router-link to="/" @click="handleClick" class="logo d-inline-block">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" src="../../assets/logos/Main/Myceleblogo.png" alt="logo" style="max-height: 40px;"/>
      </router-link>
      <button
        type="button"
        class="close-btn"
        @click="stateStoreInstance.onChange"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <i class="ri-close-fill"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <BAccordion free>
        <div class="accordion-item">
          <router-link
            to="/"
            class="accordion-link"
            @click="handleClick"
            style="color: black !important;"
          >
            HOME
          </router-link>
        </div>
        <div class="accordion-item">
          <router-link
            to="/services"
            class="accordion-link"
            @click="handleClick"
            style="color: black !important;"
          >
            SERVICES
          </router-link>
        </div>
        <div class="accordion-item">
  <router-link
    to="/our-team"
    class="accordion-link"
    @click="handleClick"
    style="color: black !important;"
  >
    GET YOUR WISH
  </router-link>
</div>

        <div class="accordion-item">
  <router-link
    to="/client"
    class="accordion-link"
    @click="handleClick"
    style="color: black !important;"
  >
    OUR CLIENTS
  </router-link>
</div>

        <div class="accordion-item">
          <router-link
            to="/about-us"
            class="accordion-link"
            @click="handleClick"
            style="color: black !important;"
          >
            ABOUT US
          </router-link>
        </div>
        
        
     <div class="accordion-item">
          <router-link
            to="/success-stories"
            class="accordion-link"
            @click="handleClick"
            style="color: black !important;"
          >
          OUR WORKS
          </router-link>
        </div>

        
        <div class="accordion-item">
          <router-link
            to="/contact-us"
            class="accordion-link"
            @click="handleClick"
            style="color: black !important;"
          >
            CONTACT US
          </router-link>
        </div>
      </BAccordion>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "../../utils/store";

export default defineComponent({
  name: "MobileNavbar",
  setup() {
    const stateStoreInstance = stateStore;
    const handleClick = () => {
      stateStoreInstance.open = false;
    };

    return {
      stateStoreInstance,
      handleClick,
    };
  },
});
</script>
